import { modules } from "../../../components/modules";
import { SECTIONS } from "../../config";
import { FLOW_MESSAGES } from "../../../components/shared/components/flowMessages/components";
import { MILESTONES } from "../../../components/shared/sharedKernel/EventCatcher/config";
import { EVENT_TYPES } from "nemuru-components";

export const flowDefaultByMerchant = {
  name: "Default by Merchant",
  modules: [
    {
      id: modules.KYC_MANUAL.id,
      onKO: null,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.DECLARED_INCOME.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            .familiar_situation_details &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.PROFESSIONAL_DATA.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "100%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.PROFESSIONAL_DETAILS_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination
            ?.professional_details,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.SUMMARY_AND_ADJUST.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "33%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.APPLICATION_CREATED_IN_LENDER,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids?.length === 0 ||
          !processState.loan?.loan_application_ids,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "66%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids &&
          processState.loan?.loan_application_ids?.length > 0,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "80%",
      },
    },
    {
      id: modules.OPTINS_AND_SIGNATURE.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "100%",
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: null,
      },
    },
  ],
};
